import './Design11.css';

function Design11() {
  return (
    <section className="features11-section">
      <div className="features11-content">
        <div className="features11-left">
          <div className="features11-label">
            <span className="features11-asterisk">*</span> LATEST NEWS
          </div>
          <h1 className="features11-title">
         Insights on digital <span className="highlight11">innovation</span> <br />
        and growth
          </h1>
        </div>
        <div className="features11-right">
          <p className="features11-desc">
Explore the latest trends, strategies, and tools driving digital innovation and helping businesses thrive in a rapidly evolving digital landscape.          </p>
          {/* <div className="features11-cta-row">
            <button className="features11-btn">
              Learn More
            </button>
            <span className="features11-btn-icon" aria-label="arrow up right">↗</span>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Design11;
